import { useEffect, useMemo, useState } from "react";

const API_BASE = "https://elshowdelasbanqueras.com/show-banqueras-api";

const ENDPOINTS = {
  create: `${API_BASE}/api/job_posts_create.php`,
  list: `${API_BASE}/api/job_posts_list.php`,
  contactPost: `${API_BASE}/api/contact_post.php`, // ✅ NUEVO
};

const PROVINCIAS = [
  "Azua","Baoruco","Barahona","Dajabón","Distrito Nacional","Duarte","Elías Piña","El Seibo","Espaillat",
  "Hato Mayor","Hermanas Mirabal","Independencia","La Altagracia","La Romana","La Vega","María Trinidad Sánchez",
  "Monseñor Nouel","Monte Cristi","Monte Plata","Pedernales","Peravia","Puerto Plata","Samaná","San Cristóbal",
  "San José de Ocoa","San Juan","San Pedro de Macorís","Sánchez Ramírez","Santiago","Santiago Rodríguez",
  "Santo Domingo","Valverde"
];

const TIPOS_PUESTO = [
  "Tiempo completo",
  "Medio tiempo",
  "Por horas",
  "Temporal",
  "Pasantía",
  "Freelance",
];

export default function HiringForm() {
  const [form, setForm] = useState({
    empresa: "",
    puesto: "",
    ciudad: "",
    provincia: "",
    tipo_puesto: "",
    horario: "",
    sueldo: "",
    beneficios_ley: false,
    requisitos: "",
    cupos: "1",
  });

  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState("");

  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState("");

  // ✅ Listado de ofertas
  const [posts, setPosts] = useState([]);
  const [listLoading, setListLoading] = useState(false);

  // ✅ Modal contacto
  const [open, setOpen] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);

  const [contactForm, setContactForm] = useState({
    tu_nombre: "",
    tu_numero: "",
    mensaje: "",
  });

  const [sending, setSending] = useState(false);
  const [sentOk, setSentOk] = useState(false);
  const [sentErr, setSentErr] = useState("");

  const canSubmit = useMemo(() => {
    return (
      form.empresa.trim() &&
      form.puesto.trim() &&
      form.ciudad.trim() &&
      form.provincia.trim() &&
      form.tipo_puesto.trim() &&
      form.horario.trim() &&
      form.requisitos.trim()
    );
  }, [form]);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((p) => ({ ...p, [name]: type === "checkbox" ? checked : value }));
  };

  const onPickPhoto = (e) => {
    const file = e.target.files?.[0] || null;
    setPhotoFile(file);

    if (photoPreview) URL.revokeObjectURL(photoPreview);
    if (file) setPhotoPreview(URL.createObjectURL(file));
    else setPhotoPreview("");
  };

  const safeJson = async (res, label) => {
    const text = await res.text();
    try {
      return JSON.parse(text);
    } catch {
      // Esto te ayuda muchísimo cuando Hostinger devuelve HTML de error
      throw new Error(`La API no devolvió JSON válido (${label}). Respuesta: ${text.slice(0, 120)}...`);
    }
  };

  const fetchPosts = async () => {
    setListLoading(true);
    setErr("");
    try {
      const res = await fetch(ENDPOINTS.list);
      const data = await safeJson(res, "job_posts_list.php");
      if (!res.ok) throw new Error(data?.message || "Error cargando ofertas");
      setPosts(Array.isArray(data) ? data : []);
    } catch (e) {
      setErr(e.message || "Error cargando ofertas");
      setPosts([]);
    } finally {
      setListLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setOk(false);
    setErr("");

    if (!canSubmit) {
      setErr("Completa los campos obligatorios.");
      return;
    }

    const cuposNum = Number(form.cupos || 1);
    if (!Number.isFinite(cuposNum) || cuposNum < 1 || cuposNum > 999) {
      setErr("Cupos debe ser un número entre 1 y 999.");
      return;
    }

    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("empresa", form.empresa.trim());
      fd.append("puesto", form.puesto.trim());
      fd.append("ciudad", form.ciudad.trim());
      fd.append("provincia", form.provincia.trim());
      fd.append("tipo_puesto", form.tipo_puesto.trim());
      fd.append("horario", form.horario.trim());
      fd.append("sueldo", form.sueldo.trim());
      fd.append("beneficios_ley", form.beneficios_ley ? "1" : "0");
      fd.append("requisitos", form.requisitos.trim());
      fd.append("cupos", String(cuposNum));
      if (photoFile) fd.append("foto", photoFile);

      const res = await fetch(ENDPOINTS.create, {
        method: "POST",
        body: fd,
      });

      const data = await safeJson(res, "job_posts_create.php");
      if (!res.ok) throw new Error(data?.message || "No se pudo guardar.");

      setOk(true);

      setForm({
        empresa: "",
        puesto: "",
        ciudad: "",
        provincia: "",
        tipo_puesto: "",
        horario: "",
        sueldo: "",
        beneficios_ley: false,
        requisitos: "",
        cupos: "1",
      });

      setPhotoFile(null);
      if (photoPreview) URL.revokeObjectURL(photoPreview);
      setPhotoPreview("");

      await fetchPosts();
      setTimeout(() => setOk(false), 2500);
    } catch (e2) {
      setErr(e2.message || "Error guardando la oferta");
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // Modal Contacto (Candidato -> Oferta)
  // =========================
  const openContact = (post) => {
    setSelectedPost(post);
    setSentOk(false);
    setSentErr("");
    setContactForm({ tu_nombre: "", tu_numero: "", mensaje: "" });
    setOpen(true);
  };

  const closeContact = () => {
    setOpen(false);
    setSelectedPost(null);
  };

  const onChangeContact = (e) => {
    const { name, value } = e.target;
    setContactForm((p) => ({ ...p, [name]: value }));
  };

  const onSubmitContact = async (e) => {
    e.preventDefault();
    setSentOk(false);
    setSentErr("");

    if (!selectedPost) return;

    if (!contactForm.tu_nombre.trim() || !contactForm.tu_numero.trim() || !contactForm.mensaje.trim()) {
      setSentErr("Completa tu nombre, tu número y el mensaje.");
      return;
    }

    setSending(true);
    try {
      const payload = {
        post_id: selectedPost.id,
        empresa: selectedPost.empresa,
        puesto: selectedPost.puesto,
        provincia: selectedPost.provincia || "",
        ciudad: selectedPost.ciudad || "",
        tu_nombre: contactForm.tu_nombre.trim(),
        tu_numero: contactForm.tu_numero.trim(),
        mensaje: contactForm.mensaje.trim(),
      };

      const res = await fetch(ENDPOINTS.contactPost, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await safeJson(res, "contact_post.php");
      if (!res.ok) throw new Error(data?.message || "No se pudo enviar la solicitud.");

      setSentOk(true);
      setTimeout(() => closeContact(), 1400);
    } catch (e2) {
      setSentErr(e2.message || "Error enviando la solicitud.");
    } finally {
      setSending(false);
    }
  };

  return (
    <main className="container">
      <form className="card" onSubmit={onSubmit} style={{ maxWidth: 860, marginInline: "auto" }}>
        <h2 style={{ marginTop: 0 }}>Estamos contratando</h2>
        <p className="p">Publica el perfil del puesto que necesitas.</p>

        {/* Foto negocio */}
        <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
          <div
            className="card"
            style={{
              width: 110,
              height: 110,
              borderRadius: 18,
              padding: 0,
              overflow: "hidden",
              display: "grid",
              placeItems: "center",
              background: "rgba(255,255,255,.06)",
              border: "2px solid rgba(255, 105, 180, .55)",
            }}
          >
            {photoPreview ? (
              <img src={photoPreview} alt="preview" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            ) : (
              <span style={{ opacity: 0.75 }}>Foto negocio</span>
            )}
          </div>

          <div style={{ flex: 1, minWidth: 240 }}>
            <label style={{ display: "block", fontWeight: 900, marginBottom: 6 }}>
              Foto del negocio (opcional)
            </label>
            <input type="file" accept="image/*" onChange={onPickPhoto} />
            <div style={{ fontSize: 12, opacity: 0.7, marginTop: 6 }}>
              JPG/PNG recomendado. Se guardará en el servidor.
            </div>
          </div>
        </div>

        <div style={{ height: 14 }} />

        <div className="grid grid-2" style={{ gap: 12 }}>
          <div>
            <label style={{ fontWeight: 900, display: "block", marginBottom: 6 }}>Empresa *</label>
            <input className="card" style={{ width: "100%", padding: 12 }}
              placeholder="Ej: Farmacia ABC" name="empresa" value={form.empresa} onChange={onChange} required />
          </div>

          <div>
            <label style={{ fontWeight: 900, display: "block", marginBottom: 6 }}>Puesto *</label>
            <input className="card" style={{ width: "100%", padding: 12 }}
              placeholder="Ej: Cajero/a, Mensajero..." name="puesto" value={form.puesto} onChange={onChange} required />
          </div>

          <div>
            <label style={{ fontWeight: 900, display: "block", marginBottom: 6 }}>Ciudad *</label>
            <input className="card" style={{ width: "100%", padding: 12 }}
              placeholder="Ej: Santiago" name="ciudad" value={form.ciudad} onChange={onChange} required />
          </div>

          <div>
            <label style={{ fontWeight: 900, display: "block", marginBottom: 6 }}>Provincia *</label>
            <select className="card" style={{ width: "100%", padding: 12 }}
              name="provincia" value={form.provincia} onChange={onChange} required>
              <option value="">Seleccione una provincia…</option>
              {PROVINCIAS.map((p) => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>

          <div>
            <label style={{ fontWeight: 900, display: "block", marginBottom: 6 }}>Tipo de puesto *</label>
            <select className="card" style={{ width: "100%", padding: 12 }}
              name="tipo_puesto" value={form.tipo_puesto} onChange={onChange} required>
              <option value="">Seleccione…</option>
              {TIPOS_PUESTO.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>

          <div>
            <label style={{ fontWeight: 900, display: "block", marginBottom: 6 }}>Horario *</label>
            <input className="card" style={{ width: "100%", padding: 12 }}
              placeholder="Ej: L-V 8:00am a 5:00pm" name="horario" value={form.horario} onChange={onChange} required />
          </div>

          <div>
            <label style={{ fontWeight: 900, display: "block", marginBottom: 6 }}>Sueldo (opcional)</label>
            <input className="card" style={{ width: "100%", padding: 12 }}
              placeholder="Ej: RD$ 25,000 / A convenir" name="sueldo" value={form.sueldo} onChange={onChange} />
          </div>

          <div>
            <label style={{ fontWeight: 900, display: "block", marginBottom: 6 }}>Cupos</label>
            <input className="card" style={{ width: "100%", padding: 12 }}
              placeholder="Ej: 1" name="cupos" value={form.cupos} onChange={onChange} inputMode="numeric" />
          </div>
        </div>

        <div style={{ height: 10 }} />

        <label style={{ display: "flex", gap: 10, alignItems: "center", fontWeight: 900 }}>
          <input type="checkbox" name="beneficios_ley" checked={form.beneficios_ley} onChange={onChange} />
          Más beneficios de ley
        </label>

        <div style={{ height: 12 }} />

        <label style={{ fontWeight: 900, display: "block", marginBottom: 6 }}>
          Descripción breve / Requisitos *
        </label>
        <textarea className="card" style={{ width: "100%", padding: 12, minHeight: 130 }}
          placeholder={"Ej:\n- Funciones: atender clientes.\n- Requisitos: puntual.\n- Experiencia: 6 meses.\n- Ubicación: ..."}
          name="requisitos" value={form.requisitos} onChange={onChange} required />

        <div style={{ height: 12 }} />

        <button className="btn btn-pink" type="submit" disabled={loading}>
          {loading ? "Publicando..." : "Publicar vacante"}
        </button>

        {err && <div style={{ marginTop: 12, color: "#ff7b7b" }}>❌ {err}</div>}
        {ok && <div style={{ marginTop: 12, color: "var(--green)" }}>✅ Vacante publicada</div>}
      </form>

      {/* LISTADO */}
      <div className="card" style={{ maxWidth: 860, margin: "16px auto 0" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
          <h3 style={{ margin: 0 }}>Ofertas publicadas</h3>
          <button className="btn btn-ghost" onClick={fetchPosts} disabled={listLoading}>
            {listLoading ? "Actualizando..." : "Actualizar"}
          </button>
        </div>

        {listLoading ? (
          <div style={{ opacity: 0.75, marginTop: 10 }}>Cargando ofertas...</div>
        ) : posts.length === 0 ? (
          <div style={{ opacity: 0.75, marginTop: 10 }}>No hay ofertas aún.</div>
        ) : (
          <div className="grid grid-2" style={{ marginTop: 12, gap: 12 }}>
            {posts.map((p) => {
              const fotoPath = (p.foto_url || "").replace(/^\/+/, "");
              const fotoSrc = fotoPath ? `${API_BASE}/${fotoPath}` : "";

              return (
                <div key={p.id} className="card" style={{ border: "2px solid rgba(255,105,180,.55)" }}>
                  {fotoSrc && (
                    <div style={{ height: 150, borderRadius: 14, overflow: "hidden", marginBottom: 10 }}>
                      <img src={fotoSrc} alt={p.empresa} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    </div>
                  )}

                  <b style={{ color: "var(--gold)" }}>{p.puesto}</b>

                  <div style={{ opacity: 0.85, fontSize: 13, marginTop: 6 }}>
                    🏢 {p.empresa} • 📍 {p.ciudad} {p.provincia ? `• 🏛️ ${p.provincia}` : ""}
                  </div>

                  <div style={{ opacity: 0.85, fontSize: 13, marginTop: 6 }}>
                    🕒 {p.horario} • 💼 {p.tipo_puesto}
                    {p.sueldo ? ` • 💰 ${p.sueldo}` : ""}
                    {Number(p.beneficios_ley) === 1 ? " • ✅ Beneficios de ley" : ""}
                    {p.cupos ? ` • 👥 Cupos: ${p.cupos}` : ""}
                  </div>

                  <p className="p" style={{ marginTop: 10 }}>{p.requisitos}</p>

                  {/* ✅ BOTÓN CONTACTAR */}
                  <button
                    className="btn btn-pink"
                    style={{ width: "100%", marginTop: 10, justifyContent: "center" }}
                    onClick={() => openContact(p)}
                  >
                    Contactar (enviar mi info)
                  </button>

                  <div style={{ fontSize: 12, opacity: 0.6, marginTop: 10 }}>
                    {p.created_at || ""}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* MODAL CONTACTO */}
      {open && selectedPost && (
        <div
          role="dialog"
          aria-modal="true"
          onClick={closeContact}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.6)",
            display: "grid",
            placeItems: "center",
            padding: 16,
            zIndex: 9999,
          }}
        >
          <div
            className="card"
            onClick={(e) => e.stopPropagation()}
            style={{ width: "min(560px, 100%)", borderRadius: 18 }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center" }}>
              <div>
                <h3 style={{ marginTop: 0, marginBottom: 6 }}>
                  Contactar empresa <span style={{ color: "var(--gold)" }}>{selectedPost.empresa}</span>
                </h3>
                <div style={{ opacity: 0.8, fontSize: 13 }}>
                  Puesto: {selectedPost.puesto} • {selectedPost.ciudad} {selectedPost.provincia ? `• ${selectedPost.provincia}` : ""}
                </div>
              </div>
              <button className="btn btn-ghost" onClick={closeContact}>Cerrar</button>
            </div>

            <div style={{ height: 10 }} />

            <form onSubmit={onSubmitContact}>
              <label style={{ fontWeight: 800, display: "block", marginBottom: 6 }}>Tu nombre</label>
              <input
                className="card"
                style={{ width: "100%", padding: 12 }}
                name="tu_nombre"
                value={contactForm.tu_nombre}
                onChange={(e) => setContactForm((p) => ({ ...p, tu_nombre: e.target.value }))}
                placeholder="Ej: Juan Pérez"
                required
              />

              <div style={{ height: 10 }} />

              <label style={{ fontWeight: 800, display: "block", marginBottom: 6 }}>Tu número (WhatsApp)</label>
              <input
                className="card"
                style={{ width: "100%", padding: 12 }}
                name="tu_numero"
                value={contactForm.tu_numero}
                onChange={(e) => setContactForm((p) => ({ ...p, tu_numero: e.target.value }))}
                placeholder="Ej: 809-000-0000"
                required
              />

              <div style={{ height: 10 }} />

              <label style={{ fontWeight: 800, display: "block", marginBottom: 6 }}>Mensaje</label>
              <textarea
                className="card"
                style={{ width: "100%", padding: 12, minHeight: 110 }}
                name="mensaje"
                value={contactForm.mensaje}
                onChange={(e) => setContactForm((p) => ({ ...p, mensaje: e.target.value }))}
                placeholder="Hola, estoy interesado/a en el puesto. Tengo experiencia en..."
                required
              />

              <div style={{ height: 12 }} />

              <button
                className="btn btn-pink"
                type="submit"
                disabled={sending}
                style={{ width: "100%", justifyContent: "center", opacity: sending ? 0.7 : 1 }}
              >
                {sending ? "Enviando..." : "Enviar solicitud"}
              </button>

              {sentErr && <div style={{ marginTop: 12, color: "#ff7b7b" }}>❌ {sentErr}</div>}
              {sentOk && <div style={{ marginTop: 12, color: "var(--green)" }}>✅ Solicitud enviada</div>}

              <div style={{ fontSize: 12, opacity: 0.65, marginTop: 10 }}>
                Por seguridad, tu número no se publica. Nosotros enviamos tu información a la empresa.
              </div>
            </form>
          </div>
        </div>
      )}
    </main>
  );
}
